import { TagsModal } from './tags-modal';

export { TagsModal };
